
export interface CommonState {
  dialogs?: any[];
  loading?: Boolean;
  routing?: Boolean;
  instructionSubjectEn?: string;
  instructionHeaderUrlEn?: string;
  instructionHeaderUrlVn?: string;
  instructionShortDescriptionEn?: string;
  instructionContentEn?: string;
  instructionSubjectVn?: string;
  instructionShortDescriptionVn?: string;
  instructionContentVn?: string;
  licenseContentVn?: string;
  licenseContentEn?: string;
}

const generateID = () => {
  const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  let value = '';
  for (let i = 0; i < 16; i++) {
    value += chars.charAt(Math.floor(Math.random() * chars.length));
  }
  return value;
};

const common = {
  state: {
    dialogs: [],
    loading: false,
    routing: false,
    instructionSubjectEn: "",
    instructionHeaderUrlEn: "",
    instructionHeaderUrlVn: "",
    instructionShortDescriptionEn: "",
    instructionContentEn: "",
    instructionSubjectVn: "",
    instructionShortDescriptionVn: "",
    instructionContentVn: "",
    licenseContentVn: "",
    licenseContentEn: "",
  } as CommonState,

  getters: {
    vueDialogItems(state: CommonState) {
      return state.dialogs;
    },
    loading(state: CommonState) {
      return state.loading;
    },
    routing(state: CommonState) {
      return state.routing;
    },
  },

  mutations: {
    ROUTE_START: (state: CommonState) => {
      state.routing = true;
    },
    ROUTE_END: (state: CommonState) => {
      state.routing = false;
    },
    LOADING_SHOW: (state: CommonState) => {
      state.loading = true;
    },
    LOADING_HIDE: (state: CommonState) => {
      state.loading = false;
    },
    ROUTING_SHOW: (state: CommonState) => {
      state.routing = true;
    },
    ROUTING_HIDE: (state: CommonState) => {
      state.routing = false;
    },
    MUTATION_TYPE_VUE_DIALOG_OPEN: (state: CommonState, payload) => {
      state.dialogs.push(payload);
    },
    MUTATION_TYPE_VUE_DIALOG_CLOSE: (state: CommonState, payload) => {
      if (state.dialogs.length <= 0) return;

      if (typeof payload === 'object' && payload !== null && 'id' in payload && payload.id > 0) {
        // specified id to close
        const id = payload.id;

        // find that item
        for (let i = 0; i < state.dialogs.length; i++) {
          if (state.dialogs[i]._id === id) {
            // delete item
            state.dialogs.splice(i, 1);
          }
        }
      } else {
        // delete the last item
        state.dialogs.pop();
      }
    },
    MUTATION_INSTRUCTION_SUBJECT_EN: (state: CommonState) => {
      state.instructionSubjectEn = "";
    },
    MUTATION_INSTRUCTION_HEADERURLEN: (state: CommonState) => {
      state.instructionHeaderUrlEn = "";
    },
    MUTATION_INSTRUCTION_HEADERURLVn: (state: CommonState) => {
      state.instructionHeaderUrlVn = "";
    },
    MUTATION_INSTRUCTION_SHORTDESCRIPTION_EN: (state: CommonState) => {
      state.instructionShortDescriptionEn = "";
    },
    MUTATION_INSTRUCTION_CONTENT_EN: (state: CommonState) => {
      state.instructionContentVn = "";
    },
    MUTATION_INSTRUCTION_SUBJECT_VN: (state: CommonState) => {
      state.instructionSubjectVn = "";
    },
    MUTATION_INSTRUCTION_SHORTDESCRIPTION_VN: (state: CommonState) => {
      state.instructionShortDescriptionVn = "";
    },
    MUTATION_INSTRUCTION_CONTENT_VN: (state: CommonState) => {
      state.instructionContentEn = "";
    },
    MUTATION_LICENSE_CONTENT_EN: (state: CommonState) => {
      state.licenseContentEn = "";
    },
    MUTATION_LICENSE_CONTENT_VN: (state: CommonState) => {
        state.licenseContentVn = "";
    },
  },
  actions: {
    vueDialogOpen(context, payload) {
      // unique id
      const id = generateID();

      // commit to open
      context.commit("MUTATION_TYPE_VUE_DIALOG_OPEN", Object.assign({ _id: id }, payload));
    },

    vueDialogClose(context, payload) {
      context.commit("MUTATION_TYPE_VUE_DIALOG_CLOSE", payload);
    }
  },
};

export default common;
